<template>
    <div class="layout-record-list">
        <div v-if="!gotData" class="layout-rl-note">正在加载数据...</div>
        <div v-else class="layout-rl-content strong-record-list">
            <virtual-list id="MyReportList" ref="vsl" class="layout-record-list-list scroll-touch"
                :data-key="'id'"
                :data-sources="recordList"
                :data-component="itemComponent"
                :estimate-size="50"
                :item-class="'list-item-fixed'" />
        </div>
    </div>
</template>

<script>
import MyReportItem from './MyReportItem.vue'
export default {
    name: 'RecordVirtualList',
    props: {
        gotData: {
            type: Boolean,
            default() { return false }
        },
        recordList: {
            type: Array,
            default() { return [] }
        }
    },
    data() {
        return {
            itemComponent: MyReportItem
        }
    },
    mounted() {
        setTimeout(() => {
            this.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            var topDiv = document.getElementsByClassName('report-title-bar')[0];
            var listDiv = document.getElementsByClassName('layout-record-list')[0];
            var contentDiv = document.getElementById('MyReportList');
            if(listDiv && topDiv) {
                setTimeout(() => {
                    listDiv.style = 'padding-top: ' + topDiv.clientHeight + 'px;';
                }, 0);
            }
            if(contentDiv) {
                contentDiv.style.height = (innerHeight-topDiv.clientHeight)+'px';
            }
        }
    }
}
</script>